import React from 'react';
import { addressFormatter } from '../Address';
import { has } from '../../../Services/helpers';
import NoValue from '../../EmptyStates/NoValue';
import { useCustomer } from '../../../Data/Customers';

const MAX_ADDRESS_SEGMENTS = 3;

const Title = ({customer, customerId, className}) => {
    const {customer: _customer} = useCustomer(customerId);

    return <span className={className ?? ''}>{getTitle(_customer || customer)}</span>
}

const getTitle = (customer) => {
    if (!customer) {
        return <NoValue />;
    }

    if (customer.type === 'Business' && has(customer.businessName)) {
        return customer.businessName;
    }

    if (has(customer.name)) {
        return customer.name;
    }

    const formattedAddress = addressFormatter(customer.address, MAX_ADDRESS_SEGMENTS);
    if (has(formattedAddress)) {
        return formattedAddress;
    }

    return customer.shortId || customer.id;
}

export default Title;

export {
    getTitle,
}
